/**
 * Rotas em que o chat não aparece: dispositivo compartilhado (totem), captura
 * de câmera e fluxos de link direto que não devem ter nada por cima.
 */
export const WEBCHAT_BLOCKED_ROUTES = [
  '/sorteiototem',
  '/checkout/reconhecimento-facial/:id',
  '/cliente/reconhecimento-facial/:hash',
  '/consentimento/:encodeClientId',
  '/pendencias/pix/:hash',
];

/**
 * Rotas em que um segmento do caminho é chave de acesso (hash de link
 * enviado ao cliente) ou id de um fluxo aberto sem login. O link da página
 * de origem gravado no lead do pré-chat leva o padrão da rota no lugar do
 * valor, para o token não ficar no Vectis à vista da Central de Vendas.
 * A ordem importa: a primeira rota que casar com o caminho inteiro vale.
 */
export const WEBCHAT_LEAD_LINK_MASKED_ROUTES = [
  '/atualizar-senha/:hash',
  '/carrinho/:hash',
  '/checkout/carrinho/:id',
  '/checkout/multiplo/:id',
  '/checkout/reconhecimento-facial/:id',
  '/checkout/finalizar-registro/:id',
  '/checkout/resumo-orcamento/:id',
  '/checkout/link-pagamento/:id',
  '/checkout/opcaopagamento/:hash',
  '/checkout/:hash',
  '/cliente/reparcelamento/troca-cartao/:hash',
  '/cliente/reparcelamento/:hash',
  '/cliente/alteracao-email/:hash',
  '/cliente/alteracao-celular/:hash',
  '/cliente/reconhecimento-facial/:hash',
  '/consentimento/:encodeClientId',
  '/indicacao/:hash',
  '/pendencias/pix/:hash',
  '/proposta-contratacao-colaborador/:hash',
];

/**
 * Telas de autenticação: quando o pré-chat pede login a partir delas, o
 * retorno reaproveita o origin que já está na URL, em vez de aninhar
 * /login?origin=/login?origin=...
 */
export const WEBCHAT_AUTHENTICATION_ROUTES = [
  '/login',
  '/registrar',
  '/recuperacao-de-senha',
  '/canais',
  '/enviar-codigo',
  '/autenticacao-documento',
  '/atualizar-senha',
];
